import { ClassConstructor, plainToClass } from 'class-transformer';

export class TypeUtil {
  static create<T>(type: ClassConstructor<T>, object: T): T {
    return plainToClass(type, object);
  }
}